
import React from 'react';

export const StatisticsSection: React.FC = () => {
  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-primary text-gray-800 mb-4">
            Números que Falam por Si
          </h2>
          <p className="text-base sm:text-lg lg:text-xl font-secondary text-gray-600">
            A confiança dos nossos pacientes em números
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
          <div className="text-center">
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-brand-primary mb-2">25+</div>
            <p className="text-sm sm:text-base text-gray-600 font-text">Avaliações Google</p>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-brand-primary mb-2">5.0</div>
            <p className="text-sm sm:text-base text-gray-600 font-text">Média de Estrelas</p>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-brand-primary mb-2">3</div>
            <p className="text-sm sm:text-base text-gray-600 font-text">Localizações</p>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-brand-primary mb-2">50+</div>
            <p className="text-sm sm:text-base text-gray-600 font-text">Pacientes Atendidos</p>
          </div>
        </div>
      </div>
    </section>
  );
};
